import React, { useEffect } from "react";
import { usePageMetadata } from "../context/PageMetadataContext";

const MAINTENANCE_HEADING = "PiScan is temporarily unavailable";
const MAINTENANCE_TITLE = "PiScan - Maintenance";
const MAINTENANCE_DESCRIPTION =
  "PiScan is temporarily unavailable while we perform maintenance and review our service operations.";

const MaintenancePage: React.FC = () => {
  const { setHeading, setTitle, setDescription } = usePageMetadata();

  useEffect(() => {
    setHeading(MAINTENANCE_HEADING);
    setTitle(MAINTENANCE_TITLE);
    setDescription(MAINTENANCE_DESCRIPTION);
  }, [setHeading, setTitle, setDescription]);

  return (
    <main className="maintenance-page">
      <section className="maintenance-panel">
        <div className="maintenance-status">Maintenance</div>
        <h1>{MAINTENANCE_HEADING}</h1>
        <p className="maintenance-lead">
          PiScan is temporarily unavailable while we perform maintenance and
          review our service operations.
        </p>
        <p className="maintenance-note">Thank you for your understanding.</p>
      </section>
    </main>
  );
};

export default MaintenancePage;
